import { render, staticRenderFns } from "./ReadMessageList.vue?vue&type=template&id=909e9cb6&scoped=true&"
import script from "./ReadMessageList.vue?vue&type=script&lang=js&"
export * from "./ReadMessageList.vue?vue&type=script&lang=js&"
import style0 from "./ReadMessageList.vue?vue&type=style&index=0&id=909e9cb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909e9cb6",
  null
  
)

export default component.exports